import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AppConfig } from '../../providers/config';
import { AppVersion } from '@ionic-native/app-version';
import { AuthProvider } from '../../providers/auth/auth';
import { TranslateService } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { ENV } from '@app/env'

@IonicPage()
@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html',
})
export class SettingsPage {
    displayName: string;
    branchName: string;
    versionNumber: any;
    userPicture: string;
    environment: string;
    language: string;
    followup: number = 10;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public auth: AuthProvider,
        private platform: Platform,
        private translateService: TranslateService,
        private storage: Storage) {

        this.environment = ENV.MODE;
        this.displayName = AppConfig.Global.profile.email;
        this.language = AppConfig.Global.profile.Language;

        this.versionNumber = ENV.VERSION;
        console.log("Cordova not accessible " + this.versionNumber);
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad SettingsPage');
    }

    changeLanguage($event){
        //this.auth.setLanguage($event).then(() => {
        //    this.language = $event;
        //    this.translateService.use(this.language);
            //this.storage.set(AppConfig.Global.client_id + '_profile', JSON.stringify(AppConfig.Global.profile)).then(() => {
            //    AppConfig.Global.profile.Language = this.language;
            //});
       // });
    }

    changeFollowUp($event)  {
        console.log($event);
    }

    logOut() {
        this.auth.logout();
    }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts